import React from 'react';
import { Flex, Icon, Text } from '@spothero/ui';
import IconCircleCheck from '@spothero/icons/checkmark-circle-filled';
import dayjs from 'utils/dayjs-duration';
const AirportCancellationCallout = ({ cancellationAllowed, cancellationMinutes = 0, isAirport, }) => {
    const shouldShowAirportCancellationCallout = () => {
        let showCancellation = false;
        if (cancellationAllowed && isAirport) {
            showCancellation = true;
        }
        return showCancellation;
    };
    if (!shouldShowAirportCancellationCallout()) {
        return null;
    }
    return (<Flex justifyContent="center" alignItems="center" mb={4} mt={{ base: 4, desktop: 0 }}>
            <Icon as={IconCircleCheck} color="green.700" fontSize="md" marginRight={1}/>
            <Text fontSize="sm">
                Cancel free until{' '}
                {cancellationMinutes > 0
            ? `${dayjs
                .duration(cancellationMinutes, 'minutes')
                .asHours()} hours before the reservation start time`
            : `start time`}
            </Text>
        </Flex>);
};
export default AirportCancellationCallout;
